document.addEventListener('DOMContentLoaded',()=>{
 const wrap=document.getElementById('jr2-mobile-search');if(!wrap)return;
 const input=document.getElementById('jr2-mobile-query'),pane=document.getElementById('jr2-mobile-results'),products=document.getElementById('jr2-mobile-products'),all=document.getElementById('jr2-search-view-all');
 const initial=products.innerHTML;
 const categories=pane.querySelector('.jr2-mobile-results__categories');
 const initialCategories=categories.innerHTML;
 const title=pane.querySelector('.jr2-mobile-results__top-title');
 const productTitle=pane.querySelector('.jr2-mobile-results__products > strong');
 const catalogUrl=pane.querySelector('.jr2-mobile-results__all-categories')?.href || '/collections/all';
 const allArrow=all?.querySelector('svg')?.outerHTML || '<span aria-hidden="true">→</span>';
 const allowedBrandHandles=new Set(['rolex','omega','tag-heuer','cartier','patek-philippe','audemars-piguet','hublot','breitling','tudor','bvlgari','richard-mille','curren','panerai','longines','vacheron-constantin','omega-x-swatch']);
 let timer,controller,collapsed=false,serial=0;
 const escape=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const backdrop=document.createElement('div');backdrop.className='jr2-search-backdrop';backdrop.setAttribute('aria-hidden','true');document.body.appendChild(backdrop);document.body.appendChild(pane);
 pane.hidden=false;pane.setAttribute('aria-hidden','true');pane.inert=true;
 function position(){const rect=wrap.getBoundingClientRect();const bottom=Math.max(0,rect.bottom);pane.style.setProperty('--jr2-drawer-top',bottom+'px');}
 function setCollapsed(v){if(collapsed===v)return;collapsed=v;wrap.classList.toggle('jr2-is-collapsed',v);document.body.classList.toggle('jr2-search-hidden',v);if(v)close();}
 function open(){setCollapsed(false);position();wrap.classList.add('jr2-panel-open');document.body.classList.add('jr2-drawer-open');pane.setAttribute('aria-hidden','false');pane.inert=false;input.setAttribute('aria-expanded','true');}
 function close(){wrap.classList.remove('jr2-panel-open');document.body.classList.remove('jr2-drawer-open');pane.setAttribute('aria-hidden','true');pane.inert=true;input.setAttribute('aria-expanded','false');}
 input.addEventListener('focus',()=>{open();search();});
 backdrop.addEventListener('click',()=>{close();input.blur();});
 const closeButton=pane.querySelector('.jr2-mobile-results__close');if(closeButton)closeButton.addEventListener('click',()=>{close();input.blur();});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){close();input.blur();}});
 document.addEventListener('click',e=>{if(!wrap.contains(e.target)&&!pane.contains(e.target)&&e.target!==backdrop)close()});

 function search(){
  const term=input.value.trim();
  const requestId=++serial;
  if(controller){controller.abort();controller=null;}
  if(all){
   all.href=term?'/search?q='+encodeURIComponent(term)+'&type=product':catalogUrl;
   all.innerHTML='<span>'+(term?'Ver todos los resultados':'Ver catálogo completo')+'</span>'+allArrow;
  }
  if(!term){
   title.textContent='Más buscadas';
   categories.hidden=false;
   categories.innerHTML=initialCategories;
   productTitle.textContent='Productos sugeridos';
   products.innerHTML=initial;
   products.removeAttribute('aria-busy');
   return;
  }
  title.textContent='Resultados para «'+term+'»';
  categories.hidden=true;
  categories.innerHTML='';
  productTitle.textContent='Relojes encontrados';
  products.setAttribute('aria-busy','true');
  products.innerHTML='<p class="jr2-mobile-search-status">Buscando coincidencias…</p>';
  controller=new AbortController();
  const shopRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  fetch(shopRoot+'search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product,collection&resources[limit]=5',{signal:controller.signal})
  .then(r=>{if(!r.ok)throw Error('Search request failed');return r.json();})
  .then(data=>{
   if(requestId!==serial)return;
   const results=data.resources?.results||{};
   const ps=results.products||[];
   const cs=(results.collections||[]).filter(c=>{
    const handle=String(c.handle||String(c.url||'').split('/').pop().split('?')[0]).toLowerCase();
    return allowedBrandHandles.has(handle);
   });
   categories.hidden=!cs.length;
   categories.innerHTML=cs.length?
    '<strong class="jr2-mobile-results__section-label">Categorías</strong><nav class="jr2-mobile-results__links jr2-mobile-results__matches" aria-label="Categorías que coinciden">'+
    cs.map(c=>'<a href="'+escape(c.url)+'"><span>'+escape(c.title)+'</span><span class="jr2-mobile-match-arrow" aria-hidden="true">→</span></a>').join('')+'</nav>':'';
   const formatted=price=>{const n=Number(price);return Number.isFinite(n)?new Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS',maximumFractionDigits:0}).format(n):'';};
   products.innerHTML=ps.length?ps.map(p=>{
    const image=p.featured_image?.url||p.image||'';
    const img=image?'<img loading="lazy" alt="" src="'+escape(image)+'">':'';
    return '<a class="jr2-mobile-product" href="'+escape(p.url)+'">'+img+'<span>'+escape(p.title)+'<small>'+escape(formatted(p.price))+'</small></span></a>';
   }).join(''):'<p class="jr2-mobile-search-status">'+(cs.length?'No hay más relojes coincidentes.':'No encontramos categorías ni relojes para esta búsqueda.')+'</p>';
   products.removeAttribute('aria-busy');
  })
  .catch(e=>{
   if(e.name==='AbortError'||requestId!==serial)return;
   categories.hidden=true;
   products.removeAttribute('aria-busy');
   products.innerHTML='<p class="jr2-mobile-search-status">No se pudieron cargar las sugerencias. Intentá nuevamente.</p>';
  });
 }
 const form=wrap.querySelector('.jr2-mobile-search__form');
 if(form)form.addEventListener('submit',e=>{if(!input.value.trim()){e.preventDefault();window.location.assign(catalogUrl);}});
 input.addEventListener('input',()=>{open();clearTimeout(timer);timer=setTimeout(search,230);});
 const icon=document.createElement('button');icon.type='button';icon.className='jr2-search-trigger';icon.setAttribute('aria-label','Abrir buscador');icon.innerHTML='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="10.8" cy="10.8" r="6.6"/><path d="m16 16 5 5"/></svg>';
 const icons=document.querySelector('.header .header__icons');if(icons){icons.insertBefore(icon,icons.firstChild);icon.addEventListener('click',()=>{setCollapsed(false);input.focus()})}
 let lastY=window.scrollY,anchorY=lastY,direction=0,ticking=false;
 function update(){const y=Math.max(0,window.scrollY),delta=y-lastY,nextDir=delta>1?1:delta< -1?-1:0;
 if(nextDir&&nextDir!==direction){direction=nextDir;anchorY=y;}
 if(y<75){setCollapsed(false);anchorY=y}
 else if(direction===1&&y-anchorY>46&&!wrap.contains(document.activeElement)){setCollapsed(true);anchorY=y}
 else if(direction===-1&&anchorY-y>30){setCollapsed(false);anchorY=y}
 if(wrap.classList.contains('jr2-panel-open'))position();
 lastY=y;ticking=false;}
 window.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}},{passive:true});
 window.addEventListener('resize',()=>{if(wrap.classList.contains('jr2-panel-open'))position()},{passive:true});
});
